import React, { useEffect, useState } from "react";
import { Checkbox } from 'antd';
import { DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, CardSchemeIcon, FlexContainer, LabelText, Text } from "../../../../design";

type Props = {
  paymentMethod: Array,
  history: Object,
  account: Object,
  deletePaymentMethod: Function,
  subType: String,
  updatePayment: Function,
  savedPaymentsLimit: number,
}

const PaymentMethodList = (props: Props) => {
  const { account, subType, updatePayment, savedPaymentsLimit } = props;
  const alpha2 = (account && account.country && account.country.alpha2);
  
 const [paymentMethod, setPaymentMethod] = useState(props.paymentMethod || null);

  useEffect(() => {
    setPaymentMethod(props.paymentMethod);
  }, [props.paymentMethod]);

  const redirect = url => {
    if (props.history) {
      props.history.push(url);
    }
  };

  return (
    <>
      {
        (alpha2 !== 'IN') && (
          <>
            <div className="px-4">
              <LabelText marginTop="30px" marginBottom="10px"> Payment Method </LabelText>
            </div>
            <hr className="my-2" />
            <FlexContainer paddingLeft="1.5rem" >
              <div style={{ display: "block" }}>
                <>
                  {
                    paymentMethod && paymentMethod.map((item) => (
                      <table style={{ marginTop: "-10px" }}>
                        <tbody>
                          {
                            item ? (
                              <tr>
                                <th>
                                  <CardSchemeIcon
                                    style={{ paddingRight: "15px", borderRadius: "3px", width: "2.8rem", verticalAlign: 'middle' }}
                                    scheme={(item && item.card) ? (item.card && item.card.scheme) : (item && item.bank) ? 'ACH' : ''} className="" />
                                </th>
                                <th>
                                  <Text
                                    fontSize="14px"
                                    marginTop="30px"
                                    marginBottom="10px"
                                    color="#0d0d0d"
                                    fontWeight="600"
                                  >
                                    ****{(item && item.card) ? (item.card && item.card.lastFour) : (item && item.bank) ? (item.bank && item.bank.lastFour) : ''}
                                  </Text>
                                  {
                                    item && item.card && (<Text
                                      fontSize="13px"
                                      marginBottom="10px"
                                      color="#6b6c6f"
                                    >
                                      Expires {`${('0' + item.card.expiryMonth).slice(-2)}/${item.card.expiryYear}`}
                                    </Text>)
                                  }
                                </th>
                                <th>
                                  <Text marginLeft="15px" paddingLeft="20px" fontWeight="600" paddingRight="10px" paddingTop="3px" paddingBottom="3px" fontSize="12px">
                                    Default
                                  </Text>
                                  <Checkbox
                                    checked={item.default}
                                    className="display-block justify-center"
                                    style={{ marginLeft: "45px" }}
                                    onChange={() => updatePayment(item)}
                                    disabled={savedPaymentsLimit === 1}
                                  />
                                </th>
                                {savedPaymentsLimit === 1 ? (
                                  <th>
                                    <Text paddingLeft="10px" fontWeight="600" paddingRight="10px" paddingTop="3px" paddingBottom="3px" fontSize="12px">
                                      Replace
                                    </Text>
                                    <ReloadOutlined style={{ color: '#6b6c6f', fontSize: '18px', cursor: 'pointer', display: 'block', justifyItems: 'center' }} onClick={() => redirect(props.history.location.pathname + '/payment-method/add' + (item.subscription2PaymentMethodGid ? '?s2PaymentMethodGid=' + item.subscription2PaymentMethodGid : ''))} />
                                  </th>
                                ) : (
                                  <th>
                                    <Text paddingLeft="10px" fontWeight="600" paddingRight="10px" paddingTop="3px" paddingBottom="3px" fontSize="12px">
                                      Delete
                                    </Text>
                                    <DeleteOutlined style={{ color: '#6b6c6f', fontSize: '18px', cursor: 'pointer', display: 'block', justifyItems: 'center' }} onClick={() => props.deletePaymentMethod(item)} />
                                  </th>
                                )}
                              </tr>
                            ) : <tr><th><p className="mt-4 text-muted">No Data</p></th></tr>
                          }
                        </tbody>
                      </table>
                    ))
                  }
                  {savedPaymentsLimit !== 1 && (
                    <Button type="secondary"
                      borderRadius="50px"
                      border="1px solid #40a9ff !important"
                      className="px-3 py-2 mt-3"
                      disabled={paymentMethod?.length >= savedPaymentsLimit}
                      onClick={() => redirect(props.history.location.pathname + '/payment-method/add')}
                    >Add a Payment Method</Button>
                  )}
                </>
              </div>
            </FlexContainer>
          </>
        )
      }
    </>
  )
};

export default PaymentMethodList;
